import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Spin, Select, InputNumber } from 'antd';

const EditUserModal = ({ user, onSave, onCancel, visible, loading, dealers }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && user) {
      form.setFieldsValue({
        name: user.name || '',
        email: user.email || '',
        password: null,
        dealer_id: user.dealer_id || null,
        download_limit: user.download_limit,
      });
    }
  }, [visible, user, form]);

  const handleSubmit = () => {
    form.validateFields()
      .then((values) => {
        onSave(user.id, values)
          .catch((error) => {
            console.error('Error saving user:', error);
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      visible={visible}
      title={`Edit User - ID: ${user?.id}`}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} danger disabled={loading}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit} loading={loading}>
          Save
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical" disabled={loading}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please input the name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Please input the email!' },
              { type: 'email', message: 'Please enter a valid email!' }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password (留空視為不更新)"
          >
            <Input autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            name="dealer_id"
            label="Dealer"
            rules={[{ required: true, message: 'Please select a dealer!' }]}
          >
            <Select placeholder="Select a dealer">
              {(dealers || []).map((dealer) => (
                <Select.Option key={dealer.id} value={dealer.id}>
                  {dealer.id} - {dealer.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="download_limit"
            label="Download Limit (GB)"
            rules={[
              { required: true, message: 'Please input the download limit!' },
              {
                validator: (_, value) =>
                  value >= 0
                    ? Promise.resolve()
                    : Promise.reject(new Error('Download limit must be a non-negative number!')),
              },
            ]}
          >
            <Input
              placeholder="Enter download limit"
              min={0}
              step={0.01} // 設置步進值為小數點
              stringMode // 確保精確度
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default EditUserModal;